/**
 * @file
 * Provides the homepage
 *
 * Anything that needs to bind to data is built using React
 *
 * Other things, mostly things for pure 'macro' styling, that is not component styling,
 * will written in pure JavaScript
 *
 */

import React, { Component } from 'react';
import styled from 'styled-components'

import './App.scss';

import Nav from './../components/Nav/';
import Header from '../components/Masthead/Masthead';
import Features from './../components/Features/Features';
import Footer from './../components/Footer/Footer';
import Contents from "../components/Sections/Content";
import WithIsScrolled from '../components/Abstract/WithIsScrolled'
import {navbarHeight} from '../utils/sizes'

// anything else should act as our index page
// react-router will take care of everything
// router.use('*', serverRenderer);
// app.use(router);
// import Loadable from 'react-loadable';
//
// const AsyncComponent = Loadable({
//     loader: () => import("./SomeComponent"),
//     loading: () => <div>loading...</div>,
// });
// const AsyncComponent = Loadable({
//     loader: () => import(/* webpackChunkName: "myNamedChunk" */ './SomeComponent'),
//     loading: () => <div>loading...</div>,
//     modules: ['myNamedChunk']
// });
class App extends Component {
    state = {
        isMobileNavFolded: true,
    }

    toggleMobileNav = () => {
        this.setState(prevState => ({
            isMobileNavFolded: !prevState.isMobileNavFolded,
        }))
    }

    onRouteChange = () => {
        this.setState({
            isMobileNavFolded: true,
        })
    }


    render() {
        const { isMobileNavFolded } = this.state

        return (
            <div className="App">
                <WithIsScrolled>
                    {({ isScrolled }) => (
                        <Nav
                            showSideNav={false}
                            transparent={!isScrolled}
                            isMobileNavFolded={isMobileNavFolded}
                            onMobileNavToggle={this.toggleMobileNav}
                            onRouteChange={this.onRouteChange}
                        />
                    )}
                </WithIsScrolled>
                <Header />
                {/*<Contents />*/}
                {/*<Features />*/}
                <Footer />
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App.js